import { styled, TextField, TextFieldProps } from '@mui/material';

export type CurrencyInputVariant = 'default';

export type StyledCurrencyInputProps = Omit<TextFieldProps, 'variant'> & {
  customVariant?: CurrencyInputVariant;
};

export const StyledCurrencyInput = styled(TextField, {
  shouldForwardProp: (prop) => prop !== 'customVariant',
})<StyledCurrencyInputProps>({});
